export default __webpack_public_path__ + "static/media/1passwordlock.faf49056.svg";